const trails_en = require('./trails.json')
export default trails_en